import { useCallback, useRef } from 'react';
import { HomeHero } from 'scripts/animations/three/home-hero';
import { runEvent } from 'scripts/animations/three/utils/run';
import { PrimaryIconMaterial, SecondaryIconMaterial } from './common/materials';
import { GLTFData } from 'scripts/animations/three/types/gltf';
import { useGLTF } from '@react-three/drei';

import ModelUrl from 'assets/gl/home/hero/headphones.glb?url';
import { HoverWrapper } from 'scripts/animations/three/helpers/hoverWrap';

type HeadphonesProps = JSX.IntrinsicElements['group'] & {
    // nothing here yet!
};

type HeadphonesGLTF = GLTFData<'body1_1' | 'body1' | 'Sweep1' | 'Sweep_1'>;

export const Headphones = (props: HeadphonesProps) => {

    const { nodes: { body1_1, body1, Sweep1, Sweep_1 } } = useGLTF(ModelUrl) as HeadphonesGLTF;

    const rootRef = useRef<THREE.Group>();

    const onHover = useCallback(() => {
        runEvent(HomeHero.Events.Hover.Headphones, { root: rootRef.current });
    }, []);

    const onHoverOut = useCallback(() => {
        runEvent(HomeHero.Events.Hover.HeadphonesOut, { root: rootRef.current });
    }, []);

    return (
        <group
            ref={rootRef}
            name="headphones"
            position={[621.8, 5, 7.57]}
            {...props}
        >
            <group name="hp_float" position={[-4.29, 3.92, 2.32]}>
                <HoverWrapper
                    name="headphones_hover"
                    onPointerEnter={onHover}
                    onPointerOut={onHoverOut}
                    position={[2.2, -14.9, 2.31]}
                    scale={[1.34, 1.64, 1.7]}
                />
                <group
                    name="headphones1"
                    position={[2.43, -29.42, -0.34]}
                    rotation={[-0.26, -1.17, -0.19]}
                    scale={2}
                >
                    <group name="Symmetry" position={[-0.01, -6.25, 0.05]} rotation={[0, 0, -Math.PI]}>
                        <mesh
                            name="body1_1"
                            geometry={body1_1.geometry}
                            material={PrimaryIconMaterial}
                            castShadow
                            receiveShadow
                            position={[33.75, 0, -0.02]}
                            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
                        />
                        <mesh
                            name="body1"
                            geometry={body1.geometry}
                            material={PrimaryIconMaterial}
                            castShadow
                            receiveShadow
                            position={[-33.75, 0, -0.02]}
                            rotation={[Math.PI / 2, 0, -Math.PI / 2]}
                        />
                    </group>
                    <mesh
                        name="Sweep1"
                        geometry={Sweep1.geometry}
                        material={PrimaryIconMaterial}
                        castShadow
                        receiveShadow
                        position={[0.02, 12.49, -0.06]}
                        rotation={[0, 0, Math.PI / 2]}
                        scale={1}
                    />
                    <mesh
                        name="Sweep_1"
                        geometry={Sweep_1.geometry}
                        material={SecondaryIconMaterial}
                        castShadow
                        receiveShadow
                        position={[0.02, 12.49, -0.06]}
                        rotation={[0, 0, Math.PI / 2]}
                        scale={1}
                    />
                </group>
            </group>
        </group>
    );
};

export const preloader = () => useGLTF.preload(ModelUrl);
